<template>
  <span v-if="!hidden" class="data-select">
    <span v-if="err">加载出错</span>
    <i v-if="!loaded" class="el-icon-loading"></i>
    <el-select
      v-if="loaded && !err"
      :value="value"
      :multiple="multiple"
      :filterable="filterable"
      :allow-create="allowCreate"
      :default-first-option="defaultFirstOption"
      @change="change"
      :size="size"
    >
      <el-option
        v-for="item in data"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </span>
</template>

<script>
export default {
  props: {
    loader: Function,
    value: [String, Number, Array],
    size: String,
    hidden: Boolean,
    multiple: Boolean,
    filterable: Boolean,
    defaultFirstOption: Boolean,
    allowCreate: Boolean
  },
  data() {
    return {
      data: [],
      loaded: false,
      err: null
    };
  },
  async mounted() {
    try {
      this.data = await this.loader();
      this.loaded = true;
    } catch (e) {
      this.err = e;
    }
  },
  methods: {
    change(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="less" scoped>
.data-select {
  /deep/.el-select {
    width: 100%;
  }
}
</style>
